/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetImportRequestResponseDto } from './GetImportRequestResponseDto';
import {
    GetImportRequestResponseDtoFromJSON,
    GetImportRequestResponseDtoFromJSONTyped,
    GetImportRequestResponseDtoToJSON,
    GetImportRequestResponseDtoToJSONTyped,
} from './GetImportRequestResponseDto';

/**
 * 
 * @export
 * @interface GetImportRequestsResponseDto
 */
export interface GetImportRequestsResponseDto {
    /**
     * 
     * @type {Array<GetImportRequestResponseDto>}
     * @memberof GetImportRequestsResponseDto
     */
    items: Array<GetImportRequestResponseDto>;
}

/**
 * Check if a given object implements the GetImportRequestsResponseDto interface.
 */
export function instanceOfGetImportRequestsResponseDto(value: object): value is GetImportRequestsResponseDto {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetImportRequestsResponseDtoFromJSON(json: any): GetImportRequestsResponseDto {
    return GetImportRequestsResponseDtoFromJSONTyped(json, false);
}

export function GetImportRequestsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetImportRequestsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GetImportRequestResponseDtoFromJSON)),
    };
}

export function GetImportRequestsResponseDtoToJSON(json: any): GetImportRequestsResponseDto {
    return GetImportRequestsResponseDtoToJSONTyped(json, false);
}

export function GetImportRequestsResponseDtoToJSONTyped(value?: GetImportRequestsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(GetImportRequestResponseDtoToJSON)),
    };
}

